export const programsKeys = {
  all: ['progrmas'],
};
